/**
 * Created by: avinersan
 * Date: 14.08.2015
 */

(function ($) {
    'use strict';

    var ui = kendo.ui,
        Widget = ui.Widget,
        TimePicker = ui.TimePicker,
        CLOSE = "close",
        ENABLE = "enable",
        ISOPEN = "isOpen",
        OPEN = "open",
        VALUE = "value",
        TEXT = "text",
        MAX = "max",
        MIN = "min",
        READONLY = "readonly",
        unwrap = TS.unwrap
    ;

    var TsTimePicker = TimePicker.extend({
        init: function (element, options) {
            var me = this,
                strVal,
                date;

            strVal = options.value;
            if (TS.isString(strVal)) {
                date = kendo.parseDate(strVal, options.parseFormats, options.culture);
                options.value = date;
            }

            TimePicker.fn.init.call(me, element, options);
        },
        options: {
            name: 'TsTimePicker',
            autoBind: false,
            animate: false
        }
    });

    ui.plugin(TsTimePicker);

    /*
        TsTimePicker
    */
    ko.kendo.bindingFactory.createBinding({
        name: "kendoTsTimePicker",
        defaultOption: VALUE,
        events: {
            change: VALUE,
            open:
            {
                writeTo: ISOPEN,
                value: true
            },
            close: {
                writeTo: ISOPEN,
                value: false
            }
        },
        watch: {
            enabled: ENABLE,
            readonly: READONLY,
            max: MAX,
            min: MIN,
            value: VALUE,
            isOpen: [OPEN, CLOSE],
            visible: ko.wrapperVisible
        }
    });

    //intercept the setup function to pass along the viewModel to widget options
    var prevSetup = ko.bindingHandlers['kendoTsTimePicker'].setup;
    ko.bindingHandlers['kendoTsTimePicker'].setup = function (element, options, context) {
        options.getViewModel = function () {
            var vm = context.$data;
            return vm;
        };

        options.animate = false;
        prevSetup.apply(this, arguments);
    }

})(jQuery);